export const SELECT_SKUS_TABLE_ID = 38;
export const DISTRIBUTE_SKUS_TABLE_ID = 36;
